import { AddressDetailsFragment, AddressInput, CountryCode } from "@/saleor/api";

export const cloneAddress = (address?: AddressDetailsFragment | null): AddressInput | null => {
	if (!address) {
		return null;
	}
	return {
		firstName: address?.firstName || "",
		lastName: address?.lastName || "",
		phone: address?.phone || "",
		country: (address?.country?.code as CountryCode) || CountryCode.Sg,
		streetAddress1: address?.streetAddress1 || "",
		streetAddress2: address?.streetAddress2 || "",
		unitNumber: address?.unitNumber || "",
		city: address?.city || "",
		postalCode: address?.postalCode || "",
	};
};
